module.exports = __webpack_public_path__ + "img/canada-female.3ac44174.png";